<button (click)="submitEvent.emit()"
  class="outline-none inline-block px-3 no-underline  font-normal text-center lg:px-4 py-2 rounded-md sm:rounded-lg lg:mr-2 transition duration-300 ease-in-out transform hover:-translate-y-1 hover:scale-110 cursor-pointer {{color}} ">
  {{title}}
</button>